import React from 'react';
import './Footer.css';


function Footer() {
    return (
        <footer className='bg-navy'>
            
        </footer>
    );
}

export default Footer;